import * as api from '../../../api';

const fetchFormListActions = api.fetchActions('touchpoint-list', 'fetch-form-list');
const fetchFormDetailsActions = api.fetchActions('touchpoint-details', 'fetch-form-details');

export const actionTypes = {
  ...fetchFormListActions.actionTypes,
  ...fetchFormDetailsActions.actionTypes,
  CHANGE_PAGE_NUMBER: 'touchpoint-list.change-page-number',
  CHANGE_SORT: 'touchpoint-list.change-sort',
  SHOW_FORM_DETAILS: 'touchpoint-list.show-form-details',
}

function shouldFetchForms(state, siteId)
{
  const { forms } = state;
  const { formLists } = forms;
  var formsState = formLists.get(siteId);
  const { formListState } = formsState || {};
  return !formListState || !(formListState.isFetching || formListState.isValid);
}

export function fetchFormList(siteId) {
  return (dispatch, getState) => {
    const state = getState();
    const { forms } = state;
    const { formLists } = forms;
    const formsState = formLists.get(siteId);
    if(shouldFetchForms(state, siteId)) {
      const { currentPage, itemsPerPage, sortBy, sortAsc } = formsState || {};

      const params = {
        page: currentPage,
        perPage: itemsPerPage,
        sortBy,
        sortAsc,
      };

      return dispatch(api.getThunk(`/sites/${siteId}/programs/0/touchpoint-forms/GetFormsBySite`, params, fetchFormListActions, { siteId }));
    }
    else {
      return Promise.resolve(formsState.formListState.formList);
    }
  }
}

/**
 * Loads touchpoint forms with full details, including elements.
 * will load the forms whose ids are present in touchpointIds, unless they have already been loaded previously.
 * @param {*} siteId
 * @param {*} touchpointIds
 */
export function loadFormDetails(siteId, touchpointIds) {
  return (dispatch, getState) => {
      const state = getState();
      const { forms } = state;
      const { allForms } = forms;
      const formIds = touchpointIds.filter(formId => {
        var formsState = allForms.get(formId);
        return !formsState || !(formsState.isFetching || formsState.isValid);
      });
      if (formIds.length === 0) return [];

      const params = {
        siteId,
        formIds,
        page: 1,
        perPage: touchpointIds.length,
      };

      return dispatch(api.postThunk(`/sites/${siteId}/programs/0/touchpoint-forms/GetFormsByIds`, params, fetchFormDetailsActions, { formIds }));
  }
}

export function changePageNumber(siteId, page) {
  return {
    type: actionTypes.CHANGE_PAGE_NUMBER,
    siteId,
    page
  }
}

export function changeSort(siteId, newSort) {
  return (dispatch, getState) => {
    const { forms } = getState();
    const { formLists } = forms;
    var formState = formLists.get(siteId);
    const { sortBy, sortAsc } = formState || {};
    if(sortBy === newSort)
      dispatch(changeSortStart(siteId, newSort, !sortAsc));
    else
      dispatch(changeSortStart(siteId, newSort, true));
  }
}

function changeSortStart(siteId, sortBy, sortAsc) {
  return {
    type: actionTypes.CHANGE_SORT,
    siteId,
    sortBy,
    sortAsc
  }
}

export function showFormDetails(siteId, id, show) {
  return {
    type: actionTypes.SHOW_FORM_DETAILS,
    siteId,
    id,
    show
  }
}
